import React, { useState, useEffect } from "react";
import classNames from 'classnames';
import throttle from 'lodash/throttle';

import { IconArrowHead } from '../index';

import css from './ScrollToTop.css'

const ScrollToTop = ({ containerClassName, buttonClassName, iconClassName }) => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const containerClasses = classNames(containerClassName, css.container);
  const buttonClasses = classNames(buttonClassName, css.btn);
  const iconClasses = classNames(iconClassName, css.iconStyle);

  const handleScroll = throttle(() => {
    if (window.scrollY > 400) {
      setShowTopBtn(true);
    } else {
      setShowTopBtn(false);
    }
  }, 100);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={containerClasses}>
      {showTopBtn && (
        <button onClick={goToTop} className={buttonClasses}>
          <IconArrowHead
            direction='up'
            className={iconClasses}
          />
        </button>
      )}
    </div>
  );
};

export default ScrollToTop;
